import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { fetchJurisdictions, Jurisdiction } from '../../redux/suggestions';
import { selectJurisdictions } from '../../selectors/suggestions';
import { AppDispatch } from '../../store';

interface JurisdictionDropDownProps {
  value: Jurisdiction | null;
  onChange: (event: React.SyntheticEvent, value: Jurisdiction | null) => void;
  label?: string;
  disabled?: boolean;
}

const JurisdictionDropDown: React.FC<JurisdictionDropDownProps> = ({
  value,
  onChange,
  label = 'Jurisdiction',
  disabled = false,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const jurisdictions = useSelector(selectJurisdictions);

  useEffect(() => {
    if (jurisdictions.length === 0) {
      dispatch(fetchJurisdictions());
    }
  }, [jurisdictions, dispatch]);

  return (
    <Autocomplete
      options={jurisdictions}
      getOptionLabel={(option) => option.name}
      value={value}
      onChange={onChange}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" placeholder="Select the jurisdiction" />
      )}
      fullWidth
    />
  );
};

export default JurisdictionDropDown;
